import { render, staticRenderFns } from "./ChecklistForm3.vue?vue&type=template&id=2dcad368"
import script from "./ChecklistForm3.vue?vue&type=script&lang=ts"
export * from "./ChecklistForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports